import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SkipButtonGroup } from '../skip-button-group/component';

import { useCreditSkip } from './hooks/use-credit-skip';
import { useAutoSkip } from './hooks/use-auto-skip';
import styles from './styles.module.css';

interface Props {
    contentId: string;
    className?: string;
    currentFragment: SkippableFragment;
}

export const NextEpisodeSkipButtonGroup: FC<Props> = ({
    contentId,
    currentFragment,
    className,
}) => {
    const { isSkipEnabled, skip, cancel, onSkipButtonShow } = useCreditSkip(
        contentId,
        currentFragment
    );

    const { duration, stopAutoSkip, dismissSkipEnabled } = useAutoSkip({
        contentId,
        currentFragment,
    });

    const intl = useIntl();

    if (!isSkipEnabled) {
        return null;
    }

    return (
        <SkipButtonGroup
            cancelButtonText={intl.formatMessage({
                id: 'features.player.2356e5f7f801f88158bdbec7b67a1e68',

                defaultMessage: 'View credits',
                description: 'Текст в группе кнопок в конце сериала для просмотра титров',
            })}
            skipButtonText={intl.formatMessage({
                id: 'features.player.f13c30cf44b49bfd339d433f89bb5bcd',

                defaultMessage: 'Next episode',
                description:
                    'Текст в группке кнопок в конце сериала для переключения на следующую серию',
            })}
            onSkipClick={() => {
                skip();
            }}
            renderSkipButtonIcon={(className) => (
                <span className={classnames(styles.icon, className)} />
            )}
            onCancelClick={() => {
                cancel();
                stopAutoSkip();
            }}
            className={className}
            autoSkipTime={duration}
            hideCancelButton={!dismissSkipEnabled}
            onSkipButtonShow={onSkipButtonShow}
        />
    );
};
